import getApiClient from '@/plugins/api'
import moment from "moment/moment";
import router from '@/router'

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`modals/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        self.modal = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    let method = 'post',
      endpoint = 'modals',
      headers = {}

    if (itemId) {
      method = 'patch'
      endpoint = `modals/${itemId}`
      headers['Content-Type'] = 'application/merge-patch+json'
    }

    if (!self.modal.startDate) {
      self.modal.startDate = null
    }

    if (!self.modal.endDate) {
      self.modal.endDate = null
    }

    if (!self.modal.persistentWithoutPagarmeIdDate) {
      self.modal.persistentWithoutPagarmeIdDate = null
    }

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')
    api[method](endpoint, self.modal, {headers: headers})
      .then(response => {
        self.modal = response.data
        self.success = true
        if (method === 'post') {
          router.push({name: 'Editar modal', params: {id: response.data.id}})
        }
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  },

  parseDate(dateString, format) {
    if (dateString.length >= 16) {
      return moment(dateString, format).toDate()
    }
  },

  setCustomerProfile(event) {
    const self = this
    const isChecked = event.target.checked

    if (!self.modal.profileTypes) {
      self.modal.profileTypes = []
    }

    if (isChecked) {
      if (!self.modal.profileTypes.includes('customer')) {
        self.modal.profileTypes.push('customer')
      }
    } else {
      self.modal.profileTypes = self.modal.profileTypes.filter(type => type !== 'customer')
    }
  },

  setAgencyProfile(event) {
    const self = this
    const isChecked = event.target.checked

    if (!self.modal.profileTypes) {
      self.modal.profileTypes = []
    }

    if (isChecked) {
      if (!self.modal.profileTypes.includes('agency')) {
        self.modal.profileTypes.push('agency')
      }
    } else {
      self.modal.profileTypes = self.modal.profileTypes.filter(type => type !== 'agency')
    }
  },

  addAction() {
    if (!this.modal.actions) {
      this.modal.actions = []
    }

    this.modal.actions.push({
      title: '',
      type: 'close',
      link: '',
      target: '_self',
      color: 'primary'
    })
  },

  removeAction(index) {
    this.modal.actions.splice(index, 1)
  },

  setActionType(index, type) {
    this.modal.actions[index].type = type

    if (type === 'link') {
      if (!this.modal.actions[index].target) {
        this.$set(this.modal.actions[index], 'target', '_self')
      }
    } else {
      this.modal.actions[index].link = ''
      this.modal.actions[index].target = '_self'
    }
  },

  moveActionUp(index) {
    if (index <= 0) {
      return
    }

    const actions = this.modal.actions
    actions.splice(index - 1, 0, actions.splice(index, 1)[0])
  },

  moveActionDown(index) {
    const actions = this.modal.actions

    if (index >= actions.length - 1) {
      return
    }

    actions.splice(index + 1, 0, actions.splice(index, 1)[0])
  },

  setWithoutPagarmeIdOnly(event) {
    this.modal.withoutPagarmeIdOnly = event.target.checked

    if (!event.target.checked) {
      this.modal.persistentWithoutPagarmeIdDate = null
    }
  }
}
